import type { IconData } from '@stacksjs/iconify-core'

export const okta: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M11.998 2a10 10 0 1 0 10 10a9.995 9.995 0 0 0-10-10m0 15.01a5.01 5.01 0 1 1 5.01-5.01a5.014 5.014 0 0 1-5.01 5.01\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default okta
